import { memo } from 'react';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { DropsList } from 'root/src/client/v2/_pages/drops/components/DropsList';
import { MainLayout } from 'root/src/client/v2/common/layouts/MainLayout';
import { useOnboardingQueryParam } from 'root/src/client/v2/onboarding/hooks/useOnboardingQueryParam';
import { DROPS_FILTER_SECTION_MAP, DROPS_STALE_TIME_MS, DROPS_TAB_SECTION_MAP, DropsFilter, DropsTabStatus, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { DropSerializer } from 'root/src/shared/drops/drops.constants';
export const DropsBanner = memo(() => {
    var _a, _b;
    const [isOnboarding] = useOnboardingQueryParam();
    const dropsQuery = trpc.drops.getDrops.useQuery({
        section: DROPS_TAB_SECTION_MAP[DropsTabStatus.Live],
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: DROPS_FILTER_SECTION_MAP[DropsFilter.All],
    }, {
        staleTime: DROPS_STALE_TIME_MS,
    });
    const drops = (_b = (_a = dropsQuery.data) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
    const availableDrops = getAvailableDrops(drops);
    const sampleDrops = getSampleDrops(drops);
    const { isLoading } = dropsQuery;
    if (isLoading) {
        return null;
    }
    if (isOnboarding && !(availableDrops === null || availableDrops === void 0 ? void 0 : availableDrops.length)) {
        return <SampleDrops drops={sampleDrops}/>;
    }
    if (isOnboarding) {
        return <DropsAvailableForUser drops={availableDrops}/>;
    }
    return null;
});
const DropsAvailableForUser = memo(({ drops }) => {
    const [isOnboarding] = useOnboardingQueryParam();
    if (!drops.length) {
        return null;
    }
    return (<div className="flex justify-center items-center bg-dark-2 p-4">
			<MainLayout>
				<h1 className="font-mono text-3xl m-8 font-bold">Drops You Can Join Right Now</h1>
				<div className="flex justify-center items-center">
					<DropsList className="justify-start flex-initial flex-nowrap overflow-x-auto" isOnboarding={isOnboarding} drops={drops}/>
				</div>
			</MainLayout>
		</div>);
});
const SampleDrops = memo(({ drops }) => {
    if (!drops.length) {
        return null;
    }
    return (<div className="flex justify-center items-center bg-dark-2 p-4">
			<MainLayout>
				<h1 className="font-mono text-3xl m-8 font-bold">See How it Works: Try a Sample Drop</h1>
				<div className="flex justify-center items-center">
					<DropsList isOnboarding className="justify-start flex-initial flex-nowrap overflow-x-auto" drops={drops}/>
				</div>
			</MainLayout>
		</div>);
});
const getAvailableDrops = (drops) => {
    return drops.filter((drop) => {
        var _a, _b, _c;
        return ((_b = (_a = drop.dropUserInfo) === null || _a === void 0 ? void 0 : _a.maxDares) !== null && _b !== void 0 ? _b : 0) > 0 && !drop.isDemo && !((_c = drop.lockStatus) === null || _c === void 0 ? void 0 : _c.isLocked);
    });
};
const getSampleDrops = (drops) => {
    return drops.filter((drop) => {
        return drop.isDemo;
    });
};
